// extracted by mini-css-extract-plugin
export default {"card":"AuthCard_card__PWhMN","auth":"AuthCard_auth__tQTAm"};